(function() {
    'use strict';
    angular
        .module('anrescowebApp')
        .factory('Customer', Customer);

    Customer.$inject = ['$resource'];

    function Customer ($resource) {
        var resourceUrl =  'api/customers/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;

                }
            },
            'update': { method:'PUT' },
            'updateQbench': {
                method: 'PATCH',
                url: 'api/customer/update/qbench',
            },
            'getPanels': {
                method: 'GET',
                url: 'api/customers/:id/panels',
                isArray: true
            }

        });
    }
})();
